<dx-form
    [items]="formItems"
    [(formData)]="formData"
    [readOnly]="$readOnly()"
    [validationGroup]="$validationGroupName()"
    [colCount]="12"
    [minColWidth]="250"
    [colCountByScreen]="{xs: 1, sm: 1, md: 12, lg: 12}"
    [showValidationSummary]="true">

</dx-form>

<app-role-permissions-list style="max-height: calc(100% - 106px)" [readOnly]="$readOnly()" [(permissions)]="permissions" />

@if (loadIndicatorVisible) {
    <app-load-indicator />
}
